import Header from "../components/global/Header";
import BusinessSheetCreationForm from "../components/business-sheet/BusinessSheetCreationForm";

const BusinessSheetCreation = () => {
  return (
    <>
      <Header />
      <BusinessSheetCreationForm />
    </>
  );
};

export default BusinessSheetCreation;
